import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Customers from "./pages/Customers";
import CustomerDetail from "./pages/CustomerDetail";
import Quotes from "./pages/Quotes";
import QuoteEditor from "./pages/QuoteEditor";
import Admin from "./pages/Admin";
import PriceList from "./pages/PriceList";
import Jobs from "./pages/Jobs";

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <div className="grid min-h-screen place-items-center font-mono text-sm text-zinc-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="price-list" element={<PriceList />} />
              <Route path="jobs" element={<Jobs />} />
              <Route path="quotes/new" element={<QuoteEditor key="new" />} />
              <Route path="quotes/:id" element={<QuoteEditor />} />
              <Route path="admin" element={<Protected admin><Admin /></Protected>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
